import { render, staticRenderFns } from "./TasksManager.vue?vue&type=template&id=4461ef82&scoped=true"
import script from "./TasksManager.vue?vue&type=script&lang=js"
export * from "./TasksManager.vue?vue&type=script&lang=js"
import style0 from "./TasksManager.vue?vue&type=style&index=0&id=4461ef82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4461ef82",
  null
  
)

export default component.exports